import {
  TooltipArrow as TooltipArrowPrimitive,
  TooltipContent as TooltipContentPrimitive,
  TooltipPortal,
  type TooltipContentProps as TooltipContentPrimitiveProps,
} from '../../primitives';
import { cn } from '../../shared';

export {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
  type TooltipProps,
  type TooltipProviderProps,
  type TooltipTriggerProps,
} from '../../primitives';

export interface TooltipContentProps extends TooltipContentPrimitiveProps {
  /** Draws the pointer. Off by default: a label rarely needs one to be read. */
  arrow?: boolean;
}

export function TooltipContent({
  className,
  sideOffset = 6,
  arrow = false,
  children,
  ...props
}: TooltipContentProps) {
  return (
    <TooltipPortal>
      <TooltipContentPrimitive
        sideOffset={sideOffset}
        className={cn(
          'z-tooltip max-w-panel-sm rounded-md shadow-overlay',
          'bg-inverse text-inverse-foreground px-tooltip-x py-tooltip-y text-caption',
          // One animation per state: two `animate-*` on the same element would
          // both set `animation` and the later declaration would simply win.
          // The side slides cover entry — data-side is set whenever it is open,
          // for `delayed-open` and `instant-open` alike — and fade covers exit.
          'data-[state=closed]:animate-fade-out',
          'data-[side=top]:animate-slide-in-from-bottom',
          'data-[side=bottom]:animate-slide-in-from-top',
          'data-[side=left]:animate-slide-in-from-right',
          'data-[side=right]:animate-slide-in-from-left',
          className,
        )}
        {...props}
      >
        {children}
        {arrow ? <TooltipArrowPrimitive className="fill-inverse" /> : null}
      </TooltipContentPrimitive>
    </TooltipPortal>
  );
}
